// default RAW praemien data if server not available

const oVermieter = {
  "VermRS": {
    "EXP": {
      "SB300": {
        "N": [{
          "von": 16000,
          "bis": 24000,
          "minimum": 0,
          "promille": 28.3
        }, { "von": 0, "bis": 10000, "minimum": 154.32, "promille": 0 }, {
          "von": 10000,
          "bis": 16000,
          "minimum": 339.88,
          "promille": 0
        }],
        "B": [{ "von": 0, "bis": 10000, "minimum": 154.32, "promille": 0 }, {
          "von": 10000,
          "bis": 16000,
          "minimum": 339.88,
          "promille": 0
        }, { "von": 16000, "bis": 24000, "minimum": 0, "promille": 28.3 }]
      },
      "SB500": {
        "N": [{ "von": 16000, "bis": 24000, "minimum": 0, "promille": 18.4 }, {
          "von": 0,
          "bis": 10000,
          "minimum": 131.17,
          "promille": 0
        }, { "von": 10000, "bis": 16000, "minimum": 288.9, "promille": 0 }],
        "B": [{ "von": 16000, "bis": 24000, "minimum": 0, "promille": 18.4 }, {
          "von": 0,
          "bis": 10000,
          "minimum": 131.17,
          "promille": 0
        }, { "von": 10000, "bis": 16000, "minimum": 288.9, "promille": 0 }]
      }
    },
    "PRE": {
      "SB300": {
        "N": [{ "von": 16000, "bis": 24000, "minimum": 0, "promille": 28.3 }, {
          "von": 0,
          "bis": 10000,
          "minimum": 154.32,
          "promille": 0
        }, { "von": 10000, "bis": 16000, "minimum": 339.88, "promille": 0 }],
        "B": [{ "von": 0, "bis": 10000, "minimum": 154.32, "promille": 0 }, {
          "von": 10000,
          "bis": 16000,
          "minimum": 339.88,
          "promille": 0
        }, { "von": 16000, "bis": 24000, "minimum": 0, "promille": 28.3 }]
      },
      "SB500": {
        "B": [{ "von": 16000, "bis": 24000, "minimum": 0, "promille": 18.4 }, {
          "von": 0,
          "bis": 10000,
          "minimum": 131.17,
          "promille": 0
        }, { "von": 10000, "bis": 16000, "minimum": 288.9, "promille": 0 }],
        "N": [{ "von": 16000, "bis": 24000, "minimum": 0, "promille": 18.4 }, {
          "von": 0,
          "bis": 10000,
          "minimum": 131.17,
          "promille": 0
        }, { "von": 10000, "bis": 16000, "minimum": 288.9, "promille": 0 }]
      }
    }
  }
};

const objData = {
  "version": "debug",
  "PBV": {
    "YOLIG": {
      "EPH": {
        "B": {
          "SB150": { "p1": 283.18 },
          "SB300": { "p1": 249.74 },
          "SB500": { "p1": 199.76 },
        },
        "N": {
          "SB150": { "p1": 283.18 },
          "SB300": { "p1": 249.74 },
          "SB500": { "p1": 199.76 },
        },
      },
      "MPH": {
        "B": {
          "SB150": { "p1": 314.67 },
          "SB300": { "p1": 277.20 },
          "SB500": { "p1": 221.72 },
        },
        "N": {
          "SB150": { "p1": 314.67 },
          "SB300": { "p1": 277.20 },
          "SB500": { "p1": 221.72 },
        },
      },
    },
    "STD": {
      "MPH": {
        "N": {
          "SB0": { "p1": 405.68 },
          "SB300": { "p1": 198.35 },
          "SB150": { "p1": 241.47 }
        }, "B": { "SB0": { "p1": 344.74 }, "SB300": { "p1": 168.42 }, "SB150": { "p1": 205.08 } }
      },
      "EPH": {
        "N": { "SB0": { "p1": 365.52 }, "SB300": { "p1": 178.7 }, "SB150": { "p1": 217.57 } },
        "B": { "SB0": { "p1": 310.61 }, "SB300": { "p1": 151.74 }, "SB150": { "p1": 184.77 } }
      }
    },
    "PRE": {
      "EPH": {
        "B": {
          "SB150": { "p1": 266.64 },
          "SB500": { "p1": 179.31 },
          "SB0": { "p1": 432.82 },
          "SB300": { "p1": 210.95 }
        },
        "N": { "SB0": { "p1": 493.53 }, "SB300": { "p1": 241.41 }, "SB150": { "p1": 303.41 }, "SB500": { "p1": 205.2 } }
      },
      "MPH": {
        "N": {
          "SB0": { "p1": 537.98 },
          "SB300": { "p1": 263.76 },
          "SB150": { "p1": 330.35 },
          "SB500": { "p1": 224.2 }
        },
        "B": {
          "SB0": { "p1": 470.58 },
          "SB300": { "p1": 229.94 },
          "SB150": { "p1": 289.57 },
          "SB500": { "p1": 195.45 }
        }
      }
    },
    "EXP": {
      "MPH": {
        "N": {
          "SB0": { "p1": 448.98 },
          "SB300": { "p1": 225.76 },
          "SB150": { "p1": 272.35 },
          "SB500": { "p1": 191.9 }
        },
        "B": {
          "SB0": { "p1": 381.58 },
          "SB300": { "p1": 191.94 },
          "SB150": { "p1": 231.57 },
          "SB500": { "p1": 163.15 }
        }
      },
      "EPH": {
        "N": {
          "SB0": { "p1": 404.53 },
          "SB300": { "p1": 203.41 },
          "SB150": { "p1": 245.41 },
          "SB500": { "p1": 172.9 }
        },
        "B": {
          "SB0": { "p1": 343.82 },
          "SB300": { "p1": 172.95 },
          "SB150": { "p1": 208.64 },
          "SB500": { "p1": 147.01 }
        }
      }
    }
  },
  "PVW": {
    "YOLIG": {
      "EPH": {
        "B": {
          "SB150": { "p1": 269.68 },
          "SB300": { "p1": 210.30 },
          "SB500": { "p1": 158.81 },
        },
        "N": {
          "SB150": { "p1": 269.68 },
          "SB300": { "p1": 210.30 },
          "SB500": { "p1": 158.81 },
        },
      },
      "MPH": {
        "B": {
          "SB150": { "p1": 299.27 },
          "SB300": { "p1": 234.30 },
          "SB500": { "p1": 176.27 },
        },
        "N": {
          "SB150": { "p1": 299.27 },
          "SB300": { "p1": 234.30 },
          "SB500": { "p1": 176.27 },
        },
      },
    },
    "STD": {
      "MPH": {
        "N": { "SB300": { "p1": 159.27 }, "SB150": { "p1": 209.06 }, "SB0": { "p1": 330.78 } },
        "B": { "SB150": { "p1": 177.72 }, "SB0": { "p1": 281.23 }, "SB300": { "p1": 135.42 } }
      },
      "EPH": {
        "N": { "SB300": { "p1": 143.51 }, "SB150": { "p1": 188.36 }, "SB0": { "p1": 298.04 } },
        "B": { "SB300": { "p1": 122.01 }, "SB150": { "p1": 160.13 }, "SB0": { "p1": 253.39 } }
      }
    },
    "PRE": {
      "EPH": {
        "B": {
          "SB0": { "p1": 379.62 },
          "SB300": { "p1": 184.09 },
          "SB150": { "p1": 245.49 },
          "SB500": { "p1": 147.27 }
        },
        "N": { "SB300": { "p1": 209.81 }, "SB150": { "p1": 278.65 }, "SB500": { "p1": 167.85 }, "SB0": { "p1": 430.8 } }
      },
      "MPH": {
        "N": {
          "SB300": { "p1": 228.71 },
          "SB150": { "p1": 302.87 },
          "SB500": { "p1": 182.97 },
          "SB0": { "p1": 468.37 }
        },
        "B": {
          "SB300": { "p1": 200.14 },
          "SB150": { "p1": 266.08 },
          "SB500": { "p1": 160.11 },
          "SB0": { "p1": 411.55 }
        }
      }
    },
    "EXP": {
      "MPH": {
        "N": {
          "SB300": { "p1": 190.71 },
          "SB150": { "p1": 244.87 },
          "SB500": { "p1": 152.57 },
          "SB0": { "p1": 379.37 }
        },
        "B": {
          "SB300": { "p1": 162.14 },
          "SB150": { "p1": 208.08 },
          "SB500": { "p1": 129.71 },
          "SB0": { "p1": 322.55 }
        }
      },
      "EPH": {
        "N": {
          "SB300": { "p1": 171.81 },
          "SB150": { "p1": 220.65 },
          "SB500": { "p1": 137.45 },
          "SB0": { "p1": 341.8 }
        },
        "B": {
          "SB300": { "p1": 146.09 },
          "SB150": { "p1": 187.49 },
          "SB500": { "p1": 116.87 },
          "SB0": { "p1": 290.62 }
        }
      }
    }
  },
  "PV": {
    "YOLIG": {
      "EPH": {
        "B": {
          "SB150": { "p1": 210.40 },
          "SB300": { "p1": 163.34 },
          "SB500": { "p1": 126.79 },
        },
        "N": {
          "SB150": { "p1": 210.40 },
          "SB300": { "p1": 163.34 },
          "SB500": { "p1": 126.79 },
        },
      },
      "MPH": {
        "B": {
          "SB150": { "p1": 236.81 },
          "SB300": { "p1": 181.57 },
          "SB500": { "p1": 139.90 },
        },
        "N": {
          "SB150": { "p1": 236.81 },
          "SB300": { "p1": 181.57 },
          "SB500": { "p1": 139.90 },
        },
      },
    },
    "STD": {
      "EPH": {
        "N": { "SB300": { "p1": 113.81 }, "SB150": { "p1": 151.73 }, "SB0": { "p1": 245.09 } },
        "B": { "SB150": { "p1": 129.04 }, "SB0": { "p1": 208.31 }, "SB300": { "p1": 96.73 } }
      },
      "MPH": {
        "B": { "SB300": { "p1": 107.37 }, "SB150": { "p1": 143.21 }, "SB0": { "p1": 231.18 } },
        "N": { "SB150": { "p1": 168.4 }, "SB0": { "p1": 272.03 }, "SB300": { "p1": 126.32 } }
      }
    },
    "EXP": {
      "MPH": {
        "N": {
          "SB300": { "p1": 157.15 },
          "SB150": { "p1": 204.96 },
          "SB500": { "p1": 121.79 },
          "SB0": { "p1": 319.62 }
        },
        "B": {
          "SB150": { "p1": 174.21 },
          "SB500": { "p1": 103.63 },
          "SB0": { "p1": 271.79 },
          "SB300": { "p1": 133.71 }
        }
      },
      "EPH": {
        "N": {
          "SB150": { "p1": 184.69 },
          "SB500": { "p1": 109.74 },
          "SB0": { "p1": 287.97 },
          "SB300": { "p1": 141.6 }
        },
        "B": { "SB150": { "p1": 156.97 }, "SB500": { "p1": 93.36 }, "SB0": { "p1": 244.87 }, "SB300": { "p1": 120.46 } }
      }
    },
    "PRE": {
      "MPH": {
        "N": {
          "SB300": { "p1": 195.15 },
          "SB150": { "p1": 262.96 },
          "SB500": { "p1": 151.24 },
          "SB0": { "p1": 408.62 }
        },
        "B": {
          "SB150": { "p1": 232.21 },
          "SB500": { "p1": 133.08 },
          "SB0": { "p1": 360.79 },
          "SB300": { "p1": 171.71 }
        }
      },
      "EPH": {
        "N": {
          "SB150": { "p1": 242.69 },
          "SB500": { "p1": 139.19 },
          "SB0": { "p1": 376.97 },
          "SB300": { "p1": 179.6 }
        },
        "B": {
          "SB150": { "p1": 214.97 },
          "SB500": { "p1": 122.81 },
          "SB0": { "p1": 333.87 },
          "SB300": { "p1": 158.46 }
        }
      }
    }
  },
  "PBW": {
    "YOLIG": {
      "EPH": {
        "B": {
          "SB150": { "p1": 299.50 },
          "SB300": { "p1": 242.96 },
          "SB500": { "p1": 196.47 },
        },
        "N": {
          "SB150": { "p1": 299.50 },
          "SB300": { "p1": 242.96 },
          "SB500": { "p1": 196.47 },
        },
      },
      "MPH": {
        "B": {
          "SB150": { "p1": 332.40 },
          "SB300": { "p1": 269.95 },
          "SB500": { "p1": 218.06 },
        },
        "N": {
          "SB150": { "p1": 332.40 },
          "SB300": { "p1": 269.95 },
          "SB500": { "p1": 218.06 },
        },
      },
    },
    "STD": {
      "MPH": {
        "N": { "SB0": { "p1": 389.19 }, "SB150": { "p1": 229.85 }, "SB300": { "p1": 169.89 } },
        "B": { "SB300": { "p1": 169.89 }, "SB150": { "p1": 229.85 }, "SB0": { "p1": 389.19 } }
      },
      "EPH": {
        "N": { "SB0": { "p1": 350.68 }, "SB300": { "p1": 153.05 }, "SB150": { "p1": 207.1 } },
        "B": { "SB0": { "p1": 350.68 }, "SB300": { "p1": 153.05 }, "SB150": { "p1": 207.1 } }
      }
    },
    "EXP": {
      "MPH": {
        "N": {
          "SB0": { "p1": 410.73 },
          "SB300": { "p1": 209.6 },
          "SB150": { "p1": 269.98 },
          "SB500": { "p1": 177.11 }
        },
        "B": { "SB300": { "p1": 209.6 }, "SB150": { "p1": 269.98 }, "SB500": { "p1": 177.11 }, "SB0": { "p1": 410.73 } }
      },
      "EPH": {
        "N": {
          "SB300": { "p1": 188.84 },
          "SB150": { "p1": 243.26 },
          "SB500": { "p1": 159.57 },
          "SB0": { "p1": 370.06 }
        },
        "B": {
          "SB300": { "p1": 188.84 },
          "SB150": { "p1": 243.26 },
          "SB500": { "p1": 159.57 },
          "SB0": { "p1": 370.06 }
        }
      }
    },
    "PRE": {
      "MPH": {
        "N": {
          "SB0": { "p1": 499.73 },
          "SB300": { "p1": 247.6 },
          "SB150": { "p1": 327.98 },
          "SB500": { "p1": 209.22 }
        },
        "B": { "SB300": { "p1": 247.6 }, "SB150": { "p1": 327.98 }, "SB500": { "p1": 209.22 }, "SB0": { "p1": 499.73 } }
      },
      "EPH": {
        "N": {
          "SB300": { "p1": 226.84 },
          "SB150": { "p1": 301.26 },
          "SB500": { "p1": 191.68 },
          "SB0": { "p1": 459.06 }
        },
        "B": {
          "SB300": { "p1": 226.84 },
          "SB150": { "p1": 301.26 },
          "SB500": { "p1": 191.68 },
          "SB0": { "p1": 459.06 }
        }
      }
    }
  },
  "PB": {
    "YOLIG": {
      "EPH": {
        "B": {
          "SB150": { "p1": 269.80 },
          "SB300": { "p1": 209.55 },
          "SB500": { "p1": 181.93 },
        },
        "N": {
          "SB150": { "p1": 269.80 },
          "SB300": { "p1": 209.55 },
          "SB500": { "p1": 181.93 },
        },
      },
      "MPH": {
        "B": {
          "SB150": { "p1": 299.71 },
          "SB300": { "p1": 232.55 },
          "SB500": { "p1": 198.70 },
        },
        "N": {
          "SB150": { "p1": 299.71 },
          "SB300": { "p1": 232.55 },
          "SB500": { "p1": 198.70 },
        },
      },
    },
    "STD": {
      "MPH": {
        "N": { "SB300": { "p1": 160.08 }, "SB150": { "p1": 207.84 }, "SB0": { "p1": 345.06 } },
        "B": { "SB150": { "p1": 207.84 }, "SB0": { "p1": 345.06 }, "SB300": { "p1": 160.08 } }
      },
      "EPH": {
        "N": { "SB150": { "p1": 187.27 }, "SB0": { "p1": 310.9 }, "SB300": { "p1": 144.23 } },
        "B": { "SB150": { "p1": 187.27 }, "SB0": { "p1": 310.9 }, "SB300": { "p1": 144.23 } }
      }
    },
    "PRE": {
      "EPH": {
        "B": {
          "SB0": { "p1": 428.69 },
          "SB300": { "p1": 205.58 },
          "SB150": { "p1": 279.49 },
          "SB500": { "p1": 182.97 }
        },
        "N": {
          "SB300": { "p1": 205.58 },
          "SB150": { "p1": 279.49 },
          "SB500": { "p1": 182.97 },
          "SB0": { "p1": 428.69 }
        }
      },
      "MPH": {
        "N": {
          "SB300": { "p1": 223.97 },
          "SB150": { "p1": 303.85 },
          "SB500": { "p1": 199.33 },
          "SB0": { "p1": 466.02 }
        },
        "B": {
          "SB300": { "p1": 223.97 },
          "SB150": { "p1": 303.85 },
          "SB500": { "p1": 199.33 },
          "SB0": { "p1": 466.02 }
        }
      }
    },
    "EXP": {
      "MPH": {
        "N": {
          "SB300": { "p1": 185.97 },
          "SB150": { "p1": 245.85 },
          "SB500": { "p1": 165.51 },
          "SB0": { "p1": 377.02 }
        },
        "B": {
          "SB300": { "p1": 185.97 },
          "SB150": { "p1": 245.85 },
          "SB500": { "p1": 165.51 },
          "SB0": { "p1": 377.02 }
        }
      },
      "EPH": {
        "N": {
          "SB300": { "p1": 167.58 },
          "SB150": { "p1": 221.49 },
          "SB500": { "p1": 149.15 },
          "SB0": { "p1": 339.69 }
        },
        "B": {
          "SB300": { "p1": 167.58 },
          "SB150": { "p1": 221.49 },
          "SB500": { "p1": 149.15 },
          "SB0": { "p1": 339.69 }
        }
      }
    }
  },
  "PW": {
    "YOLIG": {
      "MPH": {
        "N": {
          "SB150": { "p1": 192.99 },
          "SB500": { "p1": 113.99 },
          "SB0": { "p1": 307.99 },
          "SB300": { "p1": 141.99 }
        },
        "B": {
          "SB150": { "p1": 192.99 },
          "SB500": { "p1": 113.99 },
          "SB0": { "p1": 307.99 },
          "SB300": { "p1": 141.99 }
        }
      },
      "EPH": {
        "N": {
          "SB150": { "p1": 173.99 },
          "SB500": { "p1": 102.99 },
          "SB0": { "p1": 277.99 },
          "SB300": { "p1": 127.99 }
        },
        "B": { "SB150": { "p1": 173.99 }, "SB500": { "p1": 102.99 }, "SB0": { "p1": 277.99 }, "SB300": { "p1": 127.99 } }
      }
    },
    "STD": {
      "MPH": {
        "B": { "SB150": { "p1": 150.3 }, "SB0": { "p1": 254.08 }, "SB300": { "p1": 115.09 } },
        "N": { "SB150": { "p1": 150.3 }, "SB0": { "p1": 254.08 }, "SB300": { "p1": 115.09 } }
      },
      "EPH": {
        "B": { "SB150": { "p1": 135.42 }, "SB0": { "p1": 228.93 }, "SB300": { "p1": 103.69 } },
        "N": { "SB0": { "p1": 228.93 }, "SB300": { "p1": 103.69 }, "SB150": { "p1": 135.42 } }
      }
    },
    "EXP": {
      "MPH": {
        "N": {
          "SB150": { "p1": 192.91 },
          "SB500": { "p1": 113.33 },
          "SB0": { "p1": 307.71 },
          "SB300": { "p1": 141.66 }
        },
        "B": {
          "SB150": { "p1": 192.91 },
          "SB500": { "p1": 113.33 },
          "SB0": { "p1": 307.71 },
          "SB300": { "p1": 141.66 }
        }
      },
      "EPH": {
        "N": {
          "SB150": { "p1": 173.81 },
          "SB500": { "p1": 102.1 },
          "SB0": { "p1": 277.23 },
          "SB300": { "p1": 127.62 }
        },
        "B": { "SB150": { "p1": 173.81 }, "SB500": { "p1": 102.1 }, "SB0": { "p1": 277.23 }, "SB300": { "p1": 127.62 } }
      }
    },
    "PRE": {
      "MPH": {
        "N": {
          "SB150": { "p1": 250.91 },
          "SB500": { "p1": 143.73 },
          "SB0": { "p1": 396.71 },
          "SB300": { "p1": 179.66 }
        },
        "B": {
          "SB150": { "p1": 250.91 },
          "SB500": { "p1": 143.73 },
          "SB0": { "p1": 396.71 },
          "SB300": { "p1": 179.66 }
        }
      },
      "EPH": {
        "N": {
          "SB150": { "p1": 231.81 },
          "SB500": { "p1": 132.5 },
          "SB0": { "p1": 366.23 },
          "SB300": { "p1": 165.62 }
        },
        "B": { "SB150": { "p1": 231.81 }, "SB500": { "p1": 132.5 }, "SB0": { "p1": 366.23 }, "SB300": { "p1": 165.62 } }
      }
    }
  },
  "P": {
    "EXP": {
      "MPH": {
        "B": {
          "SB0": { "p1": 239.4 },
          "SB300": { "p1": 109.04 },
          "SB150": { "p1": 156.43 },
          "SB500": { "p1": 90.5 }
        },
        "N": { "SB150": { "p1": 156.43 }, "SB500": { "p1": 90.5 }, "SB300": { "p1": 109.04 }, "SB0": { "p1": 239.4 } }
      },
      "EPH": {
        "B": {
          "SB300": { "p1": 98.25 },
          "SB150": { "p1": 140.95 },
          "SB500": { "p1": 81.55 },
          "SB0": { "p1": 215.71 }
        },
        "N": { "SB300": { "p1": 98.25 }, "SB0": { "p1": 215.71 }, "SB150": { "p1": 140.95 }, "SB500": { "p1": 81.55 } }
      }
    },
    "PRE": {
      "MPH": {
        "B": {
          "SB0": { "p1": 328.4 },
          "SB300": { "p1": 147.04 },
          "SB150": { "p1": 214.43 },
          "SB500": { "p1": 122.04 }
        },
        "N": { "SB150": { "p1": 214.43 }, "SB500": { "p1": 122.04 }, "SB300": { "p1": 147.04 }, "SB0": { "p1": 328.4 } }
      },
      "EPH": {
        "B": {
          "SB300": { "p1": 136.25 },
          "SB150": { "p1": 198.95 },
          "SB500": { "p1": 113.09 },
          "SB0": { "p1": 304.71 }
        },
        "N": {
          "SB300": { "p1": 136.25 },
          "SB0": { "p1": 304.71 },
          "SB150": { "p1": 198.95 },
          "SB500": { "p1": 113.09 }
        }
      }
    },
    "STD": {
      "MPH": {
        "N": { "SB0": { "p1": 184.77 }, "SB150": { "p1": 112.21 }, "SB300": { "p1": 86.17 } },
        "B": { "SB300": { "p1": 86.17 }, "SB150": { "p1": 112.21 }, "SB0": { "p1": 184.77 } }
      },
      "EPH": {
        "B": { "SB150": { "p1": 101.11 }, "SB300": { "p1": 77.64 }, "SB0": { "p1": 166.48 } },
        "N": { "SB150": { "p1": 101.11 }, "SB300": { "p1": 77.64 }, "SB0": { "p1": 166.48 } }
      }
    }
  },
  "PBVW": {
    "YOLIG": {
      "EPH": {
        "B": {
          "SB150": { "p1": 332.71 },
          "SB300": { "p1": 267.86 },
          "SB500": { "p1": 209.80 },
        },
        "N": {
          "SB150": { "p1": 332.71 },
          "SB300": { "p1": 267.86 },
          "SB500": { "p1": 209.80 },
        },
      },
      "MPH": {
        "B": {
          "SB150": { "p1": 368.20 },
          "SB300": { "p1": 297.62 },
          "SB500": { "p1": 236.37 },
        },
        "N": {
          "SB150": { "p1": 368.20 },
          "SB300": { "p1": 297.62 },
          "SB500": { "p1": 236.37 },
        },
      },
    },
    "EXP": {
      "EPH": {
        "B": {
          "SB300": { "p1": 190.14 },
          "SB150": { "p1": 244.72 },
          "SB500": { "p1": 156.87 },
          "SB0": { "p1": 382.78 }
        },
        "N": {
          "SB300": { "p1": 223.66 },
          "SB150": { "p1": 287.96 },
          "SB500": { "p1": 184.52 },
          "SB0": { "p1": 450.39 }
        }
      },
      "MPH": {
        "N": {
          "SB150": { "p1": 319.61 },
          "SB500": { "p1": 204.79 },
          "SB0": { "p1": 499.89 },
          "SB300": { "p1": 248.23 }
        },
        "B": {
          "SB150": { "p1": 271.61 },
          "SB500": { "p1": 174.12 },
          "SB0": { "p1": 424.84 },
          "SB300": { "p1": 211.05 }
        }
      }
    },
    "PRE": {
      "EPH": {
        "B": {
          "SB300": { "p1": 228.14 },
          "SB150": { "p1": 302.72 },
          "SB500": { "p1": 188.22 },
          "SB0": { "p1": 471.78 }
        },
        "N": {
          "SB300": { "p1": 261.66 },
          "SB150": { "p1": 345.96 },
          "SB500": { "p1": 215.87 },
          "SB0": { "p1": 539.39 }
        }
      },
      "MPH": {
        "N": {
          "SB150": { "p1": 377.61 },
          "SB500": { "p1": 236.14 },
          "SB0": { "p1": 588.89 },
          "SB300": { "p1": 286.23 }
        },
        "B": {
          "SB150": { "p1": 329.61 },
          "SB500": { "p1": 205.47 },
          "SB0": { "p1": 513.84 },
          "SB300": { "p1": 249.05 }
        }
      }
    },
    "STD": {
      "MPH": {
        "N": { "SB150": { "p1": 279.73 }, "SB0": { "p1": 467.7 }, "SB300": { "p1": 209.97 } },
        "B": { "SB150": { "p1": 237.73 }, "SB0": { "p1": 397.54 }, "SB300": { "p1": 178.35 } }
      },
      "EPH": {
        "N": { "SB150": { "p1": 252.04 }, "SB0": { "p1": 421.4 }, "SB300": { "p1": 189.19 } },
        "B": { "SB150": { "p1": 214.2 }, "SB0": { "p1": 358.18 }, "SB300": { "p1": 160.7 } }
      }
    }
  },
  "V-VN": {
    "EXP": {
      "B": {
        "SB0": { "p1": 93.93 },
        "SB300": { "p1": 61.15 },
        "SB150": { "p1": 67.22 },
        "SB500": { "p1": 42.81 }
      }, "N": { "SB300": { "p1": 71.94 }, "SB0": { "p1": 110.51 }, "SB150": { "p1": 79.08 }, "SB500": { "p1": 50.36 } }
    },
    "STD": {
      "N": { "SB300": { "p1": 60.18 }, "SB0": { "p1": 100.58 }, "SB150": { "p1": 68.3 } },
      "B": { "SB300": { "p1": 51.16 }, "SB150": { "p1": 58.05 }, "SB0": { "p1": 85.49 } }
    }
  },
  "V-Familie": {
    "STD": {
      "N": { "SB150": { "p1": 108.82 }, "SB300": { "p1": 96.07 }, "SB0": { "p1": 160.18 } },
      "B": { "SB300": { "p1": 81.67 }, "SB0": { "p1": 136.15 }, "SB150": { "p1": 92.51 } }
    },
    "EXP": {
      "N": {
        "SB300": { "p1": 111.63 },
        "SB150": { "p1": 120.45 },
        "SB500": { "p1": 78.14 },
        "SB0": { "p1": 172.59 }
      }, "B": { "SB0": { "p1": 146.71 }, "SB150": { "p1": 102.39 }, "SB500": { "p1": 66.42 }, "SB300": { "p1": 94.89 } }
    }
  },
  "FzRS": {
    "STD": {
      "B": { "SB300": { "p1": 46.63 }, "SB150": { "p1": 51.52 }, "SB0": { "p1": 80.21 } },
      "N": { "SB300": { "p1": 54.9 }, "SB150": { "p1": 60.66 }, "SB0": { "p1": 94.36 } }
    },
    "EXP": {
      "N": {
        "SB300": { "p1": 62.89 },
        "SB0": { "p1": 100.58 },
        "SB150": { "p1": 70.94 },
        "SB500": { "p1": 44.02 }
      }, "B": { "SB300": { "p1": 53.5 }, "SB150": { "p1": 60.35 }, "SB500": { "p1": 37.45 }, "SB0": { "p1": 85.49 } }
    }
  },
  "Fahrer": {
    "STD": {
      "B": { "SB300": { "p1": 37.57 }, "SB150": { "p1": 42.64 } },
      "N": { "SB300": { "p1": 40.62 }, "SB150": { "p1": 46.1 } }
    },
    "EXP": {
      "N": {
        "SB300": { "p1": 48.56 },
        "SB0": { "p1": 74.59 },
        "SB150": { "p1": 53.38 },
        "SB500": { "p1": 33.99 }
      }, "B": { "SB300": { "p1": 44.92 }, "SB150": { "p1": 49.38 }, "SB500": { "p1": 31.44 }, "SB0": { "p1": 69 } }
    }
  },
  "zus. HWRS": {
    "EXP": {
      "N": {
        "SB300": { "p1": 43.22 },
        "SB150": { "p1": 55.05 },
        "SB500": { "p1": 34.58 },
        "SB0": { "p1": 90.73 }
      }, "B": { "SB300": { "p1": 43.22 }, "SB150": { "p1": 55.05 }, "SB500": { "p1": 34.58 }, "SB0": { "p1": 90.73 } }
    }
  },
  "VermRS": {
    "EXP": { "N": { "": { "p1": 18.4 } }, "B": { "": { "p1": 18.4 } } },
    "PRE": { "N": { "": { "p1": 18.4 } }, "B": { "": { "p1": 18.4 } } }
  },
  "SSR": {
    "EXP": {
      "N": {
        "SB0": { "p1": 69.14 },
        "SB300": { "p1": 33.35 },
        "SB150": { "p1": 54.63 },
        "SB500": { "p1": 28.35 },
        "": { "p1": 28.35 }
      },
      "B": {
        "SB0": { "p1": 69.14 },
        "SB300": { "p1": 33.35 },
        "SB150": { "p1": 54.63 },
        "SB500": { "p1": 28.35 },
        "": { "p1": 28.35 }
      }
    },
    "PRE": {
      "B": {
        "SB0": { "p1": 69.14 },
        "SB300": { "p1": 33.35 },
        "SB150": { "p1": 54.63 },
        "SB500": { "p1": 28.35 },
        "": { "p1": 28.35 }
      },
      "N": {
        "SB0": { "p1": 69.14 },
        "SB300": { "p1": 33.35 },
        "SB150": { "p1": 54.63 },
        "SB500": { "p1": 28.35 },
        "": { "p1": 28.35 }
      }
    }
  },
  "S&S PBVW+SSR":{"EXP":{"EPH":{"N":{"SB300":{"p1":249}}},"MPH":{"N":{"SB300":{"p1":249}}}}},
  "Cyber": { "EXP": { "N": { "SB150": { "p1": 59 } }, "B": { "SB150": { "p1": 59 } } } }
};

export default {
  praemien: objData,
  praemienvermieter: oVermieter
};
